export const numbersPattern = "[0-9]";
export const lowercaseSimpleWordsPattern = "[a-z]";
export const lowercaseSpecialWordsPattern = "[à-ü]";
export const uppercaseSimpleWordsPattern = "[A-Z]";
export const uppercaseSpecialWordsPattern = "[À-Ü]";
export const simpleWordsPattern = "[a-zA-Z]";
export const specialWordsPattern = "[à-üÀ-Ü]";
export const allWordsPattern = "[a-zA-Zà-üÀ-Ü]";
export const specialCharacters = "[^\\w\\n]|_";
